export class TimeoutError extends Error {
  constructor(message) {
    super('Resource timed out: ' + message);
    this.name = 'TimeoutError';
  }
}